import React, { useState } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { PostPasswordResetConfirmAPI } from 'api/accounts';
import { getAPIErrorMessage } from 'utils';
import { AxiosResponse } from 'axios';
import {
  PASSWORD_VALIDATE_MSG,
  PASSWORD_UNMATCH_MSG,
} from 'constants/message';

const ResetPassword: NextPage = () => {
  const router = useRouter();
  const { token } = router.query;

  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const onChangePassword2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword2(event.target.value);
  };

  const validate = () => {
    if (password.length < 10) {
      alert(PASSWORD_VALIDATE_MSG);
      return false;
    }

    if (password !== password2) {
      alert(PASSWORD_UNMATCH_MSG);
      return false;
    }

    return true;
  };

  const clickResetPassword = async () => {
    if (!validate()) return;

    if (!token) {
      alert('유효하지 않은 링크입니다.');
      return;
    }

    setIsLoading(true);

    try {
      const response: AxiosResponse = await PostPasswordResetConfirmAPI({
        token: token as string,
        new_password1: password,
        new_password2: password2,
      });

      if (response.status >= 400) {
        const message = getAPIErrorMessage(response);
        alert(message);
        setIsLoading(false);
        return;
      }

      setIsSubmitted(true);
    } catch (error) {
      alert('비밀번호 변경에 실패했습니다. 링크가 만료되었거나 유효하지 않습니다.');
    }

    setIsLoading(false);
  };

  const clickGoToLogin = () => {
    router.push('/auth/login');
  };

  if (isSubmitted) {
    return (
      <div className="mem-wrapper">
        <h2>비밀번호 재설정</h2>
        <div className="sch-wrap">
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>
              비밀번호가 성공적으로 변경되었습니다.
            </p>
            <div className="btn">
              <a onClick={clickGoToLogin}>로그인 페이지로 이동</a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="mem-wrapper">
        <h2>비밀번호 재설정</h2>
        <div className="sch-wrap">
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <p style={{ marginBottom: '20px', color: '#e74c3c' }}>
              유효하지 않은 링크입니다.
            </p>
            <div className="btn">
              <a onClick={() => router.push('/auth/find_password')}>
                비밀번호 찾기로 이동
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mem-wrapper">
      <h2>비밀번호 재설정</h2>
      <div className="sch-wrap">
        <p>
          새로운 비밀번호를 입력해주세요.
        </p>
        <div className="re-pw">
          <input
            type="password"
            placeholder="비밀번호 입력 (영문,숫자,특수기호 10자 이상)"
            title="비밀번호 입력 (영문,숫자,특수기호 10자 이상)"
            value={password}
            onChange={onChangePassword}
          />
          <input
            type="password"
            placeholder="비밀번호 확인"
            title="비밀번호 확인"
            value={password2}
            onChange={onChangePassword2}
          />
        </div>
        <div className="btn">
          <a onClick={clickResetPassword}>
            {isLoading ? '변경 중...' : '비밀번호 변경'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
